import { render, staticRenderFns } from "./ItemInspect.vue?vue&type=template&id=8f474390&"
import script from "./ItemInspect.vue?vue&type=script&lang=js&"
export * from "./ItemInspect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports